import { render, staticRenderFns } from "./TagsInputModified.vue?vue&type=template&id=58bf6b36"
import script from "./TagsInputModified.vue?vue&type=script&lang=js"
export * from "./TagsInputModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports